import {closeAll as closeBottom} from "../header-menu-bottom/header-menu-bottom.js";
import {closeAll as closeTop} from "../header-menu-top/header-menu-top.js";

const headerMobileMenu = document.querySelectorAll('.header__mobile-menu')
const headerMobileMenuWrapper = document.querySelectorAll('.header__mobile-menu-wrapper')

const mobileMenuBtnClose = document.querySelectorAll('.mobile-menu__btn-close')
const headerMobileMenuOpen = document.querySelectorAll('.header__mobile-menu-open')

headerMobileMenuOpen[0].addEventListener('click', () => {
  headerMobileMenuWrapper[0].classList.add('header__mobile-menu-wrapper--open')
  document.body.style.overflow = 'hidden'
})

mobileMenuBtnClose[0].addEventListener('click', () => {
  headerMobileMenuWrapper[0].classList.remove('header__mobile-menu-wrapper--open')
  document.body.style.overflow = 'initial'
})

document.addEventListener('click', ({ target }) => {
  if (!target.closest('.header-menu-bottom__select-btn, .header-menu-top__select-btn')) {
    closeBottom()
    closeTop()
  }
})
